import { fileToBase64 } from '@/utils/converterUtils'
import type ForeignHealthInsured from '../../models/MID/ForeignHealthInsured'
import ForeignHealthSaveDocumentRequest from '../../models/MID/requests/ForeignHealthSaveDocumentRequest'
import ForeignHealthSaveDocumentInsuredRequest from '../../models/MID/requests/ForeignHealthSaveDocumentInsuredRequest'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

export default class SaveDocumentMapper {
  static async toHolderRequest(
    quotationId: string,
    holder: ForeignHealthInsured
  ): Promise<ForeignHealthSaveDocumentRequest> {
    const documents = []

    if (holder.extraDocument?.file) {
      const extraDocumentData = await fileToBase64(holder.extraDocument.file)
      documents.push({
        fileName: holder.extraDocument.fileName,
        documentType: '4',
        riskNumber: holder.riskNumber,
        documentData: extraDocumentData
      })
    }

    return new ForeignHealthSaveDocumentRequest({
      quotationId,
      document: documents,
      policyHolder: {
        nacionality: holder.addressDetails.country,
        personType: holder.documentDetails.personType,
        documentType: holder.documentDetails.documentType,
        documentExpirationDate:
          CommonMapper.toMiddlewareDate(holder.documentDetails.documentExpirationDate) ?? undefined,
        documentNumber: holder.documentDetails.documentNumber,
        privacyPolicyConsent: holder.privacyPolicyConsent,
        asisaNewsConsent: holder.asisaNewsConsent,
        role: holder.role,
        birthDate: CommonMapper.toMiddlewareDate(holder.userDetails.birthDate),
        hasPolicyInOtherCompany: holder.hasHealthPolicy === 'yes',
        student: holder.studentSituation
      }
    })
  }

  static async toInsuredRequest(
    quotationId: string,
    insured: ForeignHealthInsured
  ): Promise<ForeignHealthSaveDocumentInsuredRequest> {
    const documentObject: {
      riskNumber: number
      fileName?: string | null
      documentType?: string
      documentData?: string
    } = { riskNumber: insured.riskNumber }

    if (insured.extraDocument?.file) {
      const extraDocumentData = await fileToBase64(insured.extraDocument.file)
      documentObject.fileName = insured.extraDocument.fileName
      documentObject.documentType = '4'
      documentObject.documentData = extraDocumentData
    }

    const documents = [documentObject]
    return new ForeignHealthSaveDocumentInsuredRequest({
      quotationId,
      document: documents,
      documentNumber: insured.documentDetails.documentNumber,
      student: insured.studentSituation
    })
  }
}
